import apiClient from './apiClient'

/**
 * Get News posts
 * @param {object} payload
 * @returns 
 */
export const getNewsPosts = async (payload) => await apiClient.get('/api/news', payload)
